import { useEffect, useRef } from 'react';
import { broadcastArtifactDelete, broadcastArtifactUpdate, closeSyncChannel, createSyncChannel, setupSyncListener } from '../lib/artifacts/sync';
import { useChatArtifactStore } from '../lib/stores/ChatArtifactStore';
/**
 * Hook for managing cross-tab artifact synchronization
 * Uses BroadcastChannel to sync artifact updates across browser tabs
 */ export function useArtifactSync() {
    const channelRef = useRef(null);
    const updateArtifact = useChatArtifactStore((state)=>state.updateArtifact);
    const deleteArtifact = useChatArtifactStore((state)=>state.deleteArtifact);
    // Initialize sync channel on mount
    useEffect(()=>{
        channelRef.current = createSyncChannel();
        if (channelRef.current) {
            const cleanup = setupSyncListener(channelRef.current, (artifactId, artifact)=>{
                // Update artifact in store when another tab broadcasts an update
                updateArtifact(artifactId, artifact);
            }, (artifactId)=>{
                // Delete artifact in store when another tab broadcasts a delete
                deleteArtifact(artifactId);
            });
            return ()=>{
                cleanup?.();
                closeSyncChannel(channelRef.current);
            };
        }
    }, [
        updateArtifact,
        deleteArtifact
    ]);
    return {
        /**
     * Broadcast an artifact update to other tabs
     */ broadcastUpdate: (artifactId, artifact)=>{
            broadcastArtifactUpdate(channelRef.current, artifactId, artifact);
        },
        /**
     * Broadcast an artifact deletion to other tabs
     */ broadcastDelete: (artifactId)=>{
            broadcastArtifactDelete(channelRef.current, artifactId);
        }
    };
}
